import { v4 as uuidv4 } from 'uuid';
import { useSelector } from 'react-redux';
import { getStateValByLS } from './pageEditor/common';
const useEventTrace = () => {
  const { getCommonData } = getStateValByLS();
  const commonData = getCommonData();
  const { getWorkspaceData } = getStateValByLS();
  const workspaceData = getWorkspaceData();

  const { applicationId, workspaceId, userProfile, tenant } = commonData;
  const userId = userProfile?.userId;
  const sessionId = userProfile?.sessionId;
  const tenantId = tenant?.tenantId;

  const { applicationName } = workspaceData;

  useSelector(state => state?.commonData?.workspaceId);
  let uniqueId = localStorage.getItem('uniqueId');
  if (!uniqueId) {
    uniqueId = uuidv4();
    localStorage.setItem('uniqueId', uniqueId);
  }
  const getDefaultReqConfig = () => {
    const requestId = uuidv4(); // Generate a unique ID for each request
    const delimiter = ';';

    const requestConfig = {
      tenantId,
      userId,
      workspaceId,
      applicationId,
      applicationName,
      sessionId,
      requestId,
      uniqueId,
    };

    const requestConfigString = Object.values(requestConfig).join(delimiter);
    return requestConfigString;
  };

  const getProductTourReqConfig = () => {
    const eventRequestId = uuidv4();

    const requestConfig = {
      tenantId,
      userId,
      workspaceId,
      usrSessionId: sessionId,
      eventRequestId,
      uniqueIdentifier: uniqueId,
    };

    return requestConfig;
  };

  return { getDefaultReqConfig, getProductTourReqConfig };
};

export default useEventTrace;
